
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { useEffect, useState } from 'react';
import { deleteVolunteeringDomain, editVolunteringDomain, getContributionFieldsHierarchy, getContributionFieldsHierarchyPortal, updateWORKerContFields } from '../../../backend/backendApis';
import HttpService from '../../../backend/requestApis';
import { Box, height } from '@mui/system';
import { Button, Grid, Paper, Typography } from '@mui/material';
import { buttonStyle, errorTextStyle } from '../../../utils/commonCSS';
import { darkGrey, green, headingBlue, red } from '../../../assets/colors';
import { useNavigate } from 'react-router-dom';
import Loader from '../../Loader';
import CustomTextField from '../../CustomTextField';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import CustomDeleteDialog from '../../CustomComponents/CustomDeleteDialog';

const ConfigWORKerContrFields = (props) => {

    const navigate = useNavigate()

    const [fieldsHierarchy, setFieldsHierarchy] =useState([])
    const [nodeStatus, setNodeStatus] = useState({})
    const [apiError, setApiError] = useState('')
    const [refreshApi, setRefreshApi] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const [isEditing, setIsEditing] = useState(null)
    const [newName, setNewName] = useState(null)
    const [nodeId, setNodeId] = useState(null)
    const [deleteDialogStatus, setDeleteDialogStatus] = useState(false)

    useEffect(() => {
        setNodeStatus({})
        setFieldsHierarchy([])
        setApiError('')
        setIsEditing(null)
        setNewName(null)
        setNodeId(null)
        setDeleteDialogStatus(false)
    }, [])

    useEffect(() => {
        try{
            setIsLoading(true)
            let options = {
            url: props?.portal ? getContributionFieldsHierarchyPortal : getContributionFieldsHierarchy,
            method: 'GET',
            params: {
                contactNumber: props.update || props.portal ?  props.contactNumber : null
            },
            headers: {
                authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
            }
            }
            HttpService(options).then((resp) => {
                let data = resp?.data?.data
                setFieldsHierarchy(data)
                setIsLoading(false)
            }).catch(err => {
                console.log('Error in fetching contributions fields hierarchy: ', err)
                setApiError('Error in fetching contribution fields hierarchy. Please contact support.')
                if(err?.status === 403){
                    localStorage.clear()
                    setIsLoading(false)
                    props?.portal ? navigate('/signUp') : navigate('/Login')
                } else {
                    setIsLoading(false)
                }   
            })
        } catch(err){
            console.log('Error in fetching the contribution fields hierarchy.')
            setApiError('Error in fetching contribution fields hierarchy. Please contact support.')
            setIsLoading(false)
        }
  }, [refreshApi])

  const updateCheckBox = (nodeId) => {
    setIsLoading(true)
    var isMember = nodeStatus[nodeId]?.isMember
    var isChanged = nodeStatus[nodeId]?.isChanged
    setNodeStatus((prev) => ({
        ...prev,
        [nodeId]: {
            ...prev[nodeId],
            isChanged: !isChanged,
            isMember: !isMember
        }
    }))
    setIsLoading(false)
  }

  const handleUpdate = async () => {
    setIsLoading(true)
    var nodeIdsAdded = []
    var nodeIdsDeleted = []
    var nodeIdArray = Object.keys(nodeStatus)
    await nodeIdArray.forEach(node => {
        if( nodeStatus[node]['isChanged']){
            if( nodeStatus[node]['isMember']){
                nodeIdsAdded.push(node)
            } else {
                nodeIdsDeleted.push(node)
            }
        }
    })

    if(nodeIdsAdded.length > 0 || nodeIdsDeleted > 0){
        let options = {
            url: updateWORKerContFields,
            method: 'POST',
            payload: {
                nodeIdsAdded: nodeIdsAdded,
                nodeIdsDeleted: nodeIdsDeleted,
                contactNumber: props.contactNumber
            },
            headers: {
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                }
            }
        }
        HttpService(options).then(resp => {
            console.log('WORKer Contribution areas updated successfully.')
            setIsLoading(false)
            setRefreshApi(!refreshApi)
        }).catch(err => {
            console.log("Error in updating WORKer contribution areas: ", err)
            if(err?.status === 403){
                localStorage.clear()
                setIsLoading(false)
                navigate('/Login')
            } else {
                setIsLoading(false)
                setApiError('Error in updating WORKer contribution areas. Please Contact Support.')
            }
        })
    } else {
        setApiError('No Change Made.')
        setIsLoading(false)
    }
  }

  const handleReset = async () => {
    setIsLoading(true)
     var nodeIdArray = Object.keys(nodeStatus)
    await nodeIdArray.forEach(node => {
        if( nodeStatus[node]['isChanged']){
            setNodeStatus((prev) => ({
                ...prev,
                [node]: {
                    ...prev[node],
                    isChanged: false,
                    isMember: !(nodeStatus[node]['isMember'])
                }
            }))
            setIsLoading(false)

        } else {
            setIsLoading(() => false)
        }
    })
  }

  const updateNewName = (value) => {
    setNewName(value)
  }

  const handleEditSubDomain = () => {
    try{
        setIsLoading(true)
        let options = {
            url: editVolunteringDomain,
            method: 'PUT',
            payload: {
                _id: nodeId,
                name: newName
            },
            headers: {
                Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
            }
        }
        HttpService(options).then(resp => {
            console.log('Volunteering Domain Edited Successfully.')
            setIsEditing(null)
            setNewName(null)
            setNodeId(null)
            setRefreshApi(!refreshApi)
        }).catch(err => {
            console.log('Error in editing Volunteering domain: ', err)
            if(err?.status === 403){
                localStorage.clear()
                setIsLoading(false)
                navigate('/Login')
            } else {
                setIsLoading(false)
                setApiError(err?.response?.data?.message)
            }
        })

    } catch(err){
        console.log('Error in editing sub domain: ', err)
        setApiError('Error in editing Subdomain. Please Contact Support.')
    }
  }

  const handleDeleteSubDomain = () => {
    let options = {
        url: deleteVolunteeringDomain,
        method: 'DELETE',
        payload: {
            _id: nodeId
        },
        headers: {
            Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
        }
    }
    HttpService(options).then(resp => {
        console.log('Successfully Deleted the Volunteering Domain')
        setDeleteDialogStatus(false)
        setRefreshApi(!refreshApi)
    }).catch(err => {
        console.log("Error in deleting the Volunteering Domain", err)
        if(err?.status === 403){
            localStorage.clear()
            setIsLoading(false)
            navigate('/Login')
        } else {
            setIsLoading(false)
            setApiError(err?.response?.data?.message)
        }
    })
  }

  const updateDeleteDialogStatus = () => {
    setDeleteDialogStatus(!deleteDialogStatus)
  }
 
const renderTree = (node) => {
    let isNodePresent = nodeStatus[node['_id']]

    if( !isNodePresent){
        let nodeObj = {
            [node['_id']]: {
                'isMember': node['isMember'],
                'isChanged': false
            } 
        }
        setNodeStatus((prev) => ({...prev, ...nodeObj}))
    }
    
    return (
  <TreeItem key={node._id} itemId={node._id} label={
    <Box style={{display: 'flex'}}>
        {node.areaType === 'child' && (props.update || props.portal) &&
        <Box style={{pointerEvents: props?.portal ? 'none' : 'auto'}}>
        <input type='checkbox' checked={nodeStatus[node['_id']]?.isMember}
            onChange={() => {
                updateCheckBox(node._id)
            }}
            // style={{pointerEvents: props.portal ? 'none': 'auto'}}
        ></input>
        </Box>}
        {node.areaType === 'child' ? 
            props.settings ?
            <>
                <Grid container spacing={1}>
                    <Grid item xs ={8.5} sm ={8.5}>
                        {(isEditing === node._id) ?
                            <Box>
                                <CustomTextField 
                                    value={newName}
                                    setFunc={updateNewName}
                                ></CustomTextField> 
                            </Box>:
                            

                            <Typography 
                                // onClick={() => setIsEditing(node._id)}
                            >
                                {node.areaName}
                            </Typography>
                            
                            
                        }
                    </Grid>
                    <Grid item xs ={1} sm ={1}>
                        {node?.WORKers?.length > 0 ? node.WORKers.length : 0 }
                    </Grid>
                    <Grid item xs ={2.5} sm ={2.5} style={{display: 'flex'}}>
                        {isEditing === node._id ?
                        <CheckIcon 
                            style={{color: headingBlue, width: '1.2rem',
                             height: '1.4rem'}}
                             onClick={() => {
                                handleEditSubDomain()
                            }}
                        >
                        </CheckIcon>
                        : 
                            <img src={require('../../../assets/images/edit_icon.png')}
                                style={{width: '1rem', height: '1rem'}}
                                onClick={() =>  {
                                    setNewName(node.areaName)
                                    setNodeId(node._id)
                                    setIsEditing(node._id)

                                }}
                            ></img>
                        }
                        {isEditing === node._id ?
                        <ClearIcon 
                            style={{color: red, width: '1.2rem',
                             height: '1.4rem'}}
                             onClick={() => setIsEditing(null)}
                             >
                        </ClearIcon>
                        : 
                        <Box style ={{opacity: node?.WORKers?.length > 0 ? 0.5 : 1}}>
                            <img src={require('../../../assets/images/delete_icons.png')}
                                style={{width: '1rem', height: '1rem', marginLeft: '0.4rem'}}
                                onClick={() => {
                                    setNodeId(node._id)
                                    updateDeleteDialogStatus()
                                }}
                            ></img>
                        </Box>}
                        
                    </Grid>
                </Grid>
            </> : 
                <>
                    {node.areaName}
                </> : 
            <>
                {node.areaName}
            </>
        }
    </Box>
    
    }>
    {Array.isArray(node.children)
      ? node.children.map((child) => renderTree(child))
      : null}
  </TreeItem>
)};

  return (
    <>
        {isLoading && <Loader/>}
        <Paper style={{padding: '0.5rem', marginTop: '1rem'}}>
            <Box style={{height: '30vh', overflow: 'auto'}}
                sx={{
                  "&::-webkit-scrollbar":{
                    display: 'none'
                  },
                  scrollbarWidth: "none",
                }}
            >
                {fieldsHierarchy?.length > 0 ?
                <TreeView >
                {fieldsHierarchy.map((node) => {
                    return renderTree(node)
                }
                    )
                }
            </TreeView> : 
                (!isLoading && apiError === '') ?
                <>
                    <Typography style={{marginTop: '1rem', color: red, display: 'flex', justifyContent: 'center'}}> No Contribution Areas Added.</Typography>
                </> : 
                    !isLoading && apiError !== '' ?
                    <>
                        <Box style={{display: 'flex', justifyContent: 'center', marginTop: '1rem'}}>
                            <Typography style={{...errorTextStyle, fontSize: '1rem'}}>{apiError}</Typography>
                        </Box>
                    </>:
                    <></>
            }

            </Box>
            
        
            {(props.update)&& <Box style={{display: 'flex', justifyContent: 'right', marginRight: '0.5rem', padding: '0.5rem 0rem 0rem 0rem'}}>
                <Button style={{...buttonStyle, backgroundColor: darkGrey, border: `1px solid ${darkGrey}`}}
                    onClick={() => {
                        handleReset()
                    }}
                > Reset </Button>
                <Button style={{...buttonStyle}}
                    onClick={() => handleUpdate()}
                > Update </Button>
            </Box>}

            <CustomDeleteDialog 
                dialogStatus={deleteDialogStatus} 
                updateFunc={updateDeleteDialogStatus}
                message='Are you sure you want to delete  the subdomain.'
                deleteFunc = {handleDeleteSubDomain}
            ></CustomDeleteDialog>
        </Paper>
    </>
  )
}

export default ConfigWORKerContrFields
